import { render, staticRenderFns } from "./ChangeTeenagerPwdForm.vue?vue&type=template&id=5db73428"
import script from "./ChangeTeenagerPwdForm.vue?vue&type=script&lang=js"
export * from "./ChangeTeenagerPwdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports